export const SET_TIME_FORMAT = 'containers/timeFormats/SET_TIME_FORMAT'
